const actions = {
  CHECK_AUTHORIZATION: 'CHECK_AUTHORIZATION',

  GRP_SWITCH_FETCH_ID:'GRP_SWITCH_FETCH_ID',
  GRP_SWITCH_LIST_ID:'GRP_SWITCH_LIST_ID',




  checkAuthorization: () => ({ type: actions.CHECK_AUTHORIZATION }),

grpSwitchfetchBYId:(listid)=>({
  type: actions.GRP_SWITCH_FETCH_ID,
  payload:{listid}
}),
grpSwitchListById: (result,success) => ({
 type: actions.GRP_SWITCH_LIST_ID,
 result,
 success
}),

};
export default actions;
